import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    AccountNo: "",
    CompanyCode: "",
    ContractNo: "",
    Name: "",
    Email: "",
    Phone: "",
    Store: "",
    SSN4: "",
    Total: "0",
    token: "",
    CustomerStatus: 0
};

export const name = "steptwo";

const slice = createSlice({
    name,
    initialState,
    reducers: {
        setAccountNo: (state, action) => {
            state.AccountNo = action.payload;
        },
        setCompanyCode: (state, action) => {
            state.CompanyCode = action.payload;
        },
        setContractNo: (state, action) => {
            state.ContractNo = action.payload;
        },
        setName: (state, action) => {
            state.Name = action.payload;
        },
        setEmail: (state, action) => {
            state.Email = action.payload;
        },
        setPhone: (state, action) => {
            state.Phone = action.payload;
        },
        setStore: (state, action) => {
            state.Store = action.payload;
        },
        setSSN4: (state, action) => {
            state.SSN4 = action.payload;
        },
        setTotal: (state, action) => {
            state.Total = action.payload;
        },
        setToken: (state, action) => {
            state.token = action.payload;
        },
        setCustomerStatus: (state, action) => {
            state.CustomerStatus = action.payload;
        },
        reset: (state) => {
            state.AccountNo = ""
            state.CompanyCode = ""
            state.ContractNo = ""
            state.Name = ""
            state.Email = ""
            state.Phone = ""
            state.Store = ""
            state.SSN4 = ""
            state.Total = "0"
            state.token = ""
            state.CustomerStatus = 0
        }
    },
});

export const { actions, reducer } = slice;

export const getAccountNo = (state) => state.steptwo.AccountNo;
export const getCompanyCode = (state) => state.steptwo.CompanyCode;
export const getContractNo = (state) => state.steptwo.ContractNo;
export const getName = (state) => state.steptwo.Name;
export const getEmail = (state) => state.steptwo.Email;
export const getPhone = (state) => state.steptwo.Phone;
export const getStore = (state) => state.steptwo.Store;
export const getSSN4 = (state) => state.steptwo.SSN4;
export const getTotal = (state) => state.steptwo.Total;
export const getToken = (state) => state.steptwo.Token;
export const getCustomerStatus = (state) => state.steptwo.CustomerStatus;